module.exports = __webpack_public_path__ + "files/02a7a101dd178e2d194838b3c1e2070f.png";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/hue-horizontal.png
// module id = 740
// module chunks = 60